import { fetchChartingEngulfingDetail } from '../api/chartingEngulfingRepository';
import { useRemoteResource } from '../services/useRemoteResource';
import { useChartingSession } from '../services/chartingSession';

export function useChartingEngulfingDetail(props) {
    const session = useChartingSession();
    return useRemoteResource({
        key: () => ['charting', session.uid, 'engulfing-detail-v1', props.ticker, props.candidate.monthStart,
            ...['open', 'high', 'low', 'close'].map(key => props.candidate.bar[key]), props.candidate.previous.high, props.candidate.previous.low],
        loader: () => fetchChartingEngulfingDetail(props.ticker, props.candidate),
        ttl: 60000,
        enabled: () => session.isAuthenticated && Boolean(props.ticker && props.candidate)
    });
}
